import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import ar from '@angular/common/locales/ar';
import es from '@angular/common/locales/es';
import it from '@angular/common/locales/it';
import fr from '@angular/common/locales/fr';
import de from '@angular/common/locales/de';
import hi from '@angular/common/locales/hi';
import zh from '@angular/common/locales/zh';
import ru from '@angular/common/locales/ru';
import km from '@angular/common/locales/km';
import 'moment/locale/ar';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/hi';
import 'moment/locale/zh-cn';
import 'moment/locale/ru';
import 'moment/locale/km';
import { activeLanguage } from './services/localization';

[ar,es,it,fr,de,hi,ru,km].forEach(data=>registerLocaleData(data));
registerLocaleData(zh,'zh-Hans');

@Pipe({name:'localizedDate', standalone:true, pure:false})
export class LocalizedDatePipe implements PipeTransform {
  private locale = "";
  private datePipe: DatePipe;
  transform(value: any, format = 'mediumDate', timezone?: string) {
    const locale = activeLanguage().locale;
    if (this.locale !== locale) { this.locale = locale; this.datePipe = new DatePipe(locale); }
    return this.datePipe.transform(value, format, timezone);
  }
}
